import styled, { keyframes } from 'styled-components';

const circleConfig = [
  {
    cx: 24.5,
    cy: 4,
    r: 4,
    opacity: 1,
    fillOpacity: 1,
    transform: 'rotate(90 24.5 4)',
  },
  {
    cx: 24.5,
    cy: 44,
    r: 4,
    opacity: 0.3,
    fillOpacity: 0.3,
    transform: 'rotate(90 24.5 44)',
  },
  {
    cx: 44.5,
    cy: 24,
    r: 4,
    opacity: 0.15,
    fillOpacity: 0.15,
    transform: 'rotate(90 44.5 24)',
  },
  {
    cx: 4.5,
    cy: 24,
    r: 4,
    opacity: 0.65,
    fillOpacity: 0.65,
    transform: 'rotate(90 4.5 24)',
  },
  {
    cx: 38.642,
    cy: 38.1421,
    r: 4,
    opacity: 0.2,
    fillOpacity: 0.2,
    transform: 'rotate(135 38.642 38.1421)',
  },
  {
    cx: 10.3578,
    cy: 9.85779,
    r: 4,
    opacity: 0.85,
    fillOpacity: 0.85,
    transform: 'rotate(135 10.3578 9.85779)',
  },
  {
    cx: 10.3579,
    cy: 38.1421,
    r: 4,
    opacity: 0.5,
    fillOpacity: 0.5,
    transform: 'rotate(-135 10.3579 38.1421)',
  },
  {
    cx: 38.6421,
    cy: 9.85779,
    r: 4,
    opacity: 0.05,
    fillOpacity: 0.05,
    transform: 'rotate(-135 38.6421 9.85779)',
  },
];

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderOverlay = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  background-color: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  z-index: 9999;
`;

export const LoaderIcon = styled.svg`
  width: 48px;
  height: 48px;
  animation: ${rotate} 1.5s linear infinite;
  z-index: 10000;
`;

const Loader = () => (
  <LoaderOverlay id="loading-element" aria-hidden={true}>
    <LoaderIcon width="48" height="48" viewBox="0 0 48 48" fill="none">
      {circleConfig.map((circle, index) => (
        <circle
          key={index}
          cx={circle.cx}
          cy={circle.cy}
          r={circle.r}
          transform={circle.transform}
          fill="#F58A3C"
          opacity={circle.opacity}
          fillOpacity={circle.fillOpacity}
        />
      ))}
    </LoaderIcon>
  </LoaderOverlay>
);

export default Loader;
